/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { ClrMainContainerModule } from "./main-container/main-container.module";
import { ClrNavigationModule } from "./nav/navigation.module";
import { ClrTabsModule } from "./tabs/tabs.module";
var ClrLayoutModule = (function () {
    function ClrLayoutModule() {
    }
    return ClrLayoutModule;
}());
export { ClrLayoutModule };
ClrLayoutModule.decorators = [
    { type: NgModule, args: [{
                exports: [
                    ClrMainContainerModule,
                    ClrNavigationModule,
                    ClrTabsModule
                ]
            },] },
];
/** @nocollapse */
ClrLayoutModule.ctorParameters = function () { return []; };
//# sourceMappingURL=layout.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/layout/layout.module.js
// module id = 186
// module chunks = 4